// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"09ba7c3d","977":"28f11ef7"}[chunkId] + ".chunk.js";
};